<app-header></app-header>
<div class="container">
    <div class="row">
        <div class="col-xs-12">
            <h3 class="center-block">My Account</h3>
            <div *ngIf="unSub">
                <p>Subscription Date:- <strong>{{activation_date | date: 'dd-MM-yyyy'}}</strong></p>
                <p>Next Renewal Date:- <strong>{{expiry_date | date: 'dd-MM-yyyy'}}</strong></p>

                <p>If you wish to unsubscribe click on below unsubscribe button.</p>

                <a (click)="unsubcribe();" class="btn-play" style="text-transform: uppercase;">UNSUBCRIBE</a>
            </div>
            <div *ngIf="!unSub">
                You are not Subscribe to the GameZKlub service.
            </div>
            <br><br>
            <div class="otherlink" routerLink="/tnc">Terms of Use</div>
            <div class="otherlink" routerLink="/privacy-policy">Privacy Policy</div>
            <div class="otherlink" routerLink="/faq">Faq</div>


        </div>
    </div>
</div>
<app-footer></app-footer>

<div class="popup" *ngIf="unSubModalBox">
    <div class="modal-dialog modal-width">
        <div class="modal-content">
            <div class="modal-header">
                <!-- <button type="button" class="close" (click)="closeModal()">
                    <span aria-hidden="true" data-dismiss="modal">×</span>
                </button> -->
                <h3 class="modal-title modal-title-color">We are currently processing your request for unsubscribing.
                </h3>
                <a type="button" routerLink="/lp" class="btn btn-primary" (click)="closeModal()">OK</a>
            </div>
        </div>
    </div>
</div>